import React, { ReactNode } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import PageHeader from '../components/page-header/page-header';
import CookieMessage from '../components/cookie-message/cookie-message';

import './Page.scss';
import { PAGES_BASE_PATHNAMES } from '../core/consts';
import PageFooter from '../components/page-footer/page-footer';

interface OwnProps {
  children: ReactNode
}

type Props = OwnProps & RouteComponentProps;

class Page extends React.PureComponent<Props> {
  render() {
    const { children, history } = this.props;

    const basePath: string = history.location.pathname.split('/').find(path => !!path) || '';

    //TODO - Oren - move to config if more full width pages are added
    const isContainer: boolean = ![PAGES_BASE_PATHNAMES.Home, PAGES_BASE_PATHNAMES.Login, PAGES_BASE_PATHNAMES.SignUp, PAGES_BASE_PATHNAMES.Catalog].find(pathName => pathName === `/${basePath}`);

    return (
      <React.Fragment>
        <PageHeader />
        <div className={`page ndp-${basePath ? basePath : 'homepage'} ${isContainer ? 'container' : ''}`}>{children}</div>
        <PageFooter />
        <CookieMessage />
      </React.Fragment>
    );
  }
}

//@ts-ignore
export default withRouter(Page);
